import type { ReactNode } from "react";

import SignedInBar from "@/components/SignedInBar";

/**
 * The frame for signed-in screens that are not about one body of water: the
 * picker, adding a pool, the account page, the site overview. The app shell
 * carries a vessel's navigation; these have none, but they still need to say
 * who is signed in and offer the way out.
 */
export function HouseholdHeader({ wide = false }: { wide?: boolean }) {
  return <SignedInBar wide={wide} />;
}

export default function HouseholdShell({
  title,
  subtitle,
  action,
  wide = false,
  children,
}: {
  title: string;
  subtitle?: string;
  /** Something that sits on the title row — a cancel link, a back link. */
  action?: ReactNode;
  wide?: boolean;
  children: ReactNode;
}) {
  return (
    <div className="min-h-dvh">
      <HouseholdHeader />
      <main className={`mx-auto px-4 py-8 ${wide ? "max-w-3xl" : "max-w-lg"}`}>
        <div className="flex items-baseline justify-between gap-3">
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          {action}
        </div>
        {subtitle && <p className="mt-1 text-sm text-(--color-ink-muted)">{subtitle}</p>}
        <div className="mt-6">{children}</div>
      </main>
    </div>
  );
}
